import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  mode: 'history',
  base: process.env.NODE_ENV === "production" ? "../" : "/",
  routes,
})
router.beforeEach(async(to, from, next) => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  next();
})

export default router
